<script>
    import { onMount } from "svelte"

    import ModalApplication from "../components/ModalApplication.svelte"
    import ModalUser from "../components/ModalUser.svelte"
    import ModalSignUp from "../components/ModalSignUp.svelte"
    import ToastComponent from "../components/ToastComponent.svelte"

    import Applications from '../services/applications'
    import User from '../services/user'
    import Signup from "../services/signup"
    import { notifications } from '../services/notification'

    let applicationsList = []
    let usersList = []
    let signupList = []

    let modalApplicationComponent
    let modalUserComponent
    let modalSignUp

    onMount(async () => {

        try {
            let aresult = await Applications.getApplications()
            if(aresult.success) applicationsList = aresult.data
            if(!aresult.success) notifications.danger(aresult.data.message)

            let uresult = await User.getAllUsers()
            if(uresult.success) usersList = uresult.data
            if(!uresult.success) notifications.danger(uresult.data.message)

            let sresult = await Signup.getActiveSignupLinks()
            if(sresult.success) signupList = sresult.data
            if(!sresult.success) notifications.danger(sresult.data.message)
        } catch (e) {
            console.log(e)
            notifications.danger(e)
        }

    })

    const handleModalApplicationComponent = async (message) => {
        console.log("message", message.detail)
        let result = message.detail.data
        if(result.success) {
            notifications.success("L'application a été modifiée avec succès")
            let aresult = await Applications.getApplications()
            if(aresult.success) applicationsList = aresult.data
        } else {
            notifications.danger(result.data.message)
        }
    }

    const handleModalUserComponent = async (message) => {
        console.log("message", message.detail)
        let result = message.detail.data
        if(result.success) {
            notifications.success("L'utilisateur a été modifié avec succès")
            let uresult = await User.getAllUsers()
            if(uresult.success) usersList = uresult.data
            let sresult = await Signup.getActiveSignupLinks()
            if(sresult.success) signupList = sresult.data      
        } else {
            notifications.danger(result.data.message)
        }
    }

    const handleModalSignUpComponent = async (message) => {
        console.log("message", message.detail)
        let result = message.detail.data
        if(result.success) {
            notifications.success("Le lien a été créé avec succès")
            let sresult = await Signup.getActiveSignupLinks()
            if(sresult.success) signupList = sresult.data
        } else {
            notifications.danger(result.data.message)
        }
    }

    const createApp = () => {
        modalApplicationComponent.start()
    }

    const modifyApp = (uid) => {
        if(!uid) return
        modalApplicationComponent.start(uid)
    }

    const modifyUser = (uid) => {
        if(!uid) return
        modalUserComponent.start(uid)
    }

    const createLink = () => {
        modalSignUp.start()
    }

    const timestampToDate = (timestamp) => {
        const dtFormat = new Intl.DateTimeFormat('fr-FR', {timeZone: 'UTC'})
        return dtFormat.format(new Date(timestamp))
    }

    const copyToClipboard = (link) => {
        navigator.clipboard.writeText(`http://localhost:5000/signup/${link}`)
        notifications.success("Le lien a été copié dans le presse-papier")
    }

</script>

<!-- <pre>{JSON.stringify(usersList, undefined, 1)}</pre> -->

<!-- <Navbar></Navbar> -->

<div class="container">	
    <div class="row pt-4">
        <div class="col-md-4 mt-4">
            <div class="row m-0 p-0">
                <div class="col m-0 p-0">
                    <h2 class="text-white" id="apps">Applications</h2>
                </div>
                <div class="col-auto">
                    <button type="button" on:click={createApp} class="btn btn-light">+</button>
                </div>
            </div>
            
            <p class="text-white m-0 mb-4">Liste des applications existantes</p>
            {#each applicationsList as application}
            <div class="row ">
                <div class="col-md-12">
                    <button type="button" class="btn btn-light button-style" on:click={modifyApp(application._id)}>
                        <img class="icon" src="icons/{application.icon}" alt=""/>
                        {application.name}
                        {#if application.is_active}
                            <div class="round bg-success"></div>
                        {:else}
                            <div class="round bg-warning"></div>
                        {/if}
                    </button>
                </div>
            </div>
            {/each}        
        </div>
        
        <div class="col-md-4 mt-4">

            <h2 class="text-white"  id="users">Utilisateurs</h2>
            <p class="text-white m-0 mb-4">Liste des utilisateurs existants</p>

            {#each usersList as user}
                
            <div class="row ">
                <div class="col-md-12">
                    <button type="button" class="btn btn-light button-style" on:click={modifyUser(user._id)}>
                        {user.username}
                        <span class="badge bg-light text-black">{user.role}</span>
                        <!-- <span>{timestampToDate(user.created_at)}</span> -->
                    </button>
                </div>
            </div>
            {/each}        
        </div>

        <div class="col-md-4 mt-4">

            <div class="row m-0 p-0">
                <div class="col m-0 p-0">
                    <h2 class="text-white" id="apps">Liens</h2>
                </div>
                <div class="col-auto">
                    <button type="button" on:click={createLink} class="btn btn-light">+</button>
                </div>
            </div>
            <p class="text-white m-0 mb-4">Liste des liens actifs</p>

            {#each signupList as link}
            <div class="row ">
                <div class="col-md-12">
                    <button type="button" class="btn btn-light button-style" on:click={copyToClipboard(link.uuid)}>
                        {link.username}
                        {#if link.type === 'reset'}
                        <span class="badge bg-warning text-black">reset</span>
                        {:else}
                        <span class="badge bg-primary text-black">new</span>
                        {/if}
                    </button>
                </div>
            </div>
            {/each} 
        </div>

    </div>
</div>

<ModalApplication bind:this="{modalApplicationComponent}" on:message={handleModalApplicationComponent}></ModalApplication>
<ModalUser bind:this="{modalUserComponent}" on:message={handleModalUserComponent}></ModalUser>
<ModalSignUp bind:this="{modalSignUp}" on:message={handleModalSignUpComponent}></ModalSignUp>
<ToastComponent></ToastComponent>

<style>

.round {
    width: 15px;
    height:  15px;
    border-radius: 50%;
    float:right;
}

.icon {
    width : 35px;
}

.badge {
    font-weight: 600;
    text-transform: uppercase;
}

.button-style {
    background-color: #f8f9fad9;
    width: 100%;
    margin-bottom: 15px;
    padding: 10px;
    text-align: left;
}

</style>
